module.exports = __webpack_public_path__ + "static/img/group28_3.gif";